module.exports = __webpack_public_path__ + "static/media/pasta.2aba2169.jpg";